<template>
    <div>
      <vs-table search :data="posSettings">
        <template slot="header">
          <h3>
            Pos Ayarları
          </h3>
        </template>
        <template slot="thead">
          <vs-th class="w-6/12" sort-key="branchName">
            Şube
          </vs-th>
          <vs-th class="w-1/12" sort-key="enabled">
            Durum
          </vs-th>
          <vs-th class="w-6/12" sort-key="modified">
            Değişiklik Tarihi
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td :data="data[indextr].branchName">
              {{data[indextr].branchName}}
            </vs-td>

            <vs-td :data="data[indextr].enabled" vs-align="center" >
                <vs-switch
                  class="ml-2"
                  v-model="data[indextr].enabled"
                  @input="onPosStatusChange(data[indextr], $event)"
                >
                <span slot="on">Aktif</span>
                <span slot="off">Pasif</span>
              </vs-switch>
            </vs-td>

            <vs-td :data="data[indextr].modified">
              {{data[indextr].modifiedString}}
            </vs-td>
          </vs-tr>
        </template>


      </vs-table>
    </div>
  </template>

  <script>
  import { getAllPosSettings, setPosStatus } from "@/api/AppSettings";
  export default {
    data:()=>({
      posSettings:[

      ]
    }),
    created() {
      this.loadPosSettings();
    },
    activated() {
      this.loadPosSettings();
    },
    methods:{
        async loadPosSettings() {
          try {
            const res = await getAllPosSettings();
            this.posSettings = res.data || [];
          } catch (e) {
            this.posSettings = [];
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: e.message || "Liste yüklenemedi.",
            });
          }
        },
        async onPosStatusChange(tr, enabled) {
          try {
            const res = await setPosStatus(tr.branchId, enabled);
            if (res && res.status === 200 && res.data === true) {
              await this.loadPosSettings();
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Pos Cihaz Ayarları Güncellendi !",
              });
            } else {
              tr.enabled = !enabled;
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Pos Cihaz Ayarları Güncellenemedi !",
              });
            }
          } catch (e) {
            tr.enabled = !enabled;
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: e.message || "Sunucu Bağlantı Hatası !",
            });
          }
        }
    }
  }
  </script>
